import React from 'react'
import DELayout from '../../components/Default/LayoutDE'
import { H2Blue, UnderlineYellow } from '../../components/Typography'
import './styles.css'
import {
  Position,
  Name,
  WrapRow,
} from '../../components/Homepage/OurTeam/styled'
import { ResponsiveImage } from '../../components/ResponsiveImage'
import { Link } from '@reach/router'

import { graphql, useStaticQuery } from 'gatsby'
import './../../components/Homepage/LandingPhoto/styles.css'
import dane from './../../../static/images/dane.png'
import firemniporadenstvi from './../../../static/images/firemniPoradenstvi.png'
import mzdy from './../../../static/images/mzdy.png'
import ucetnictvi from './../../../static/images/ucetnictvi.png'
import Img from 'gatsby-image'
const DE = ({ photo }) => {
  return (
    <DELayout
      meta={{
        title: 'EK Partners',
        description:
          'EK Partners - Wir helfen unseren Klienten auf dem Gebiet der Steuern und Buchhaltung. ',
      }}
    >
      <div className="LandingPhoto">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-12"
            style={{ backgroundColor: '#e2e1dd' }}
          >
            <Img fluid={photo.fluid} alt="Homepage photo" />
          </div>
          <div className="col-xl-5 offset-xl-1 col-lg-12">
            <div className="container row justify-content-center">
              <div className="h1-mobile col-12">
                <h1>EK Partners, s.r.o.</h1>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/de/dienstleistungen/#taxes">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Right">
                    <img src={dane} alt="Daně" />
                    <h2>Steuer</h2>
                  </div>
                </Link>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/de/dienstleistungen/#accounting">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Left">
                    <img src={ucetnictvi} alt="Účetnictví" />
                    <h2>Betriebsberatung</h2>
                  </div>
                </Link>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/de/dienstleistungen/#transactions">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Right">
                    <img src={firemniporadenstvi} alt="Firemní poradenství" />
                    <h2>Transaktion</h2>
                  </div>
                </Link>
              </div>
              <div className="col-xl-6 col-lg-3 col-sm-6 col-12 wrapper">
                <Link to="/de/dienstleistungen/#consulting">
                  <div className="LandingPhoto--Wrap LandingPhoto--WrapXL--Left">
                    <img src={mzdy} alt="Mzdy" />
                    <h2>Buchhaltung und löhne</h2>
                  </div>
                </Link>
              </div>
              <div className="h1-desktop col-12">
                <h2 className="h2-mobile">EK Partners, s.r.o.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Paragraph--Wrapper container">
        <H2Blue>ÜBER UNS</H2Blue>
        <UnderlineYellow />
        <p style={{ marginTop: '5.8rem' }}>
          Wir helfen unseren Klienten auf dem Gebiet der Steuern und
          Buchhaltung. Unsere Berater haben jahrelange Erfahrung in
          Beratungsgesellschaften hinter sich.
        </p>
        <p id="team">
          Bei unserer Arbeit orientieren wir uns vor allem auf die Steuern in
          der Tschechischen Republik, auf Transaktionen, die mit der Übertragung
          von Eigentum und anderen Werten verbunden sind, auf
          Unternehmensberatung sowie auf Buchhaltung und Löhne. Außerdem
          fertigen wir Sachverständigengutachten zur Steuer- und
          Buchhaltungsthematik an. Wir arbeiten effektiv – unsere Klienten
          können sich so bereits im Vorfeld auf ihr Unternehmen konzentrieren.
        </p>
        <div>
          <H2Blue>UNSER TEAM</H2Blue>
          <UnderlineYellow />
          <WrapRow>
            <div className="row align-items-center">
              <div className="col-lg-12 blue-line-two"></div>
              <div className="col-md-6">
                <ResponsiveImage
                  className="img-transform-scale"
                  src={`/images/team/lukas_eisenwort.jpg`}
                  alt="lukas-eisenwort"
                  width="252"
                />
                <Name>Lukáš Eisenwort</Name>
                <Position>Partner, Steuerberater</Position>
              </div>
              <div className="col-md-6">
                <ResponsiveImage
                  className="img-transform-scale"
                  src={`/images/team/jan_kotala.jpg`}
                  alt="jan-kotala"
                  width="252"
                />
                <Name>Jan Kotala</Name>
                <Position>Partner, Steuerberater</Position>
              </div>
            </div>
          </WrapRow>
        </div>
      </div>
    </DELayout>
  )
}

const DEData = () => {
  const { homepageLanding } = useStaticQuery(graphql`
    query {
      homepageLanding: file(relativePath: { eq: "homepage-landing.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <DE photo={homepageLanding.childImageSharp} />
}

export default DEData
